<template>
  <div  class="modal-investment">
    <div class="window-header">
      <h3 class="title">Detalle de facturas Solicitud <b>{{ id }}</b></h3>
      <button class="button-close" @click="$modal.hide('invoices-details'), invoicesDetailsData = []">×</button>
    </div>
    <transition name="fade" mode="out-in">
      <Preloader v-if="invoicesDetailsStatus === false"></Preloader>
      <div class="modal-content" v-if="invoicesDetailsStatus">
        <table>
          <tr>
            <th width="20%">Nombre pagador</th>
            <th width="15%">
              <a href="#" @click.prevent="toggleAmount('-amount')" v-if="!amount">Monto ↓</a>
              <a href="#" @click.prevent="toggleAmount('amount')" v-if="amount">Monto ↑</a>
            </th>
            <th width="20%">Afectado por IVA</th>
            <th>Folio</th>
          </tr>
          <tr v-for="invoice in invoicesDetailsData.results" :key="invoice.id">
            <td>{{ invoice.payer.name }}</td>
            <td>{{ formatCurrency(invoice.amount) }}</td>
            <td class="-centered-info">{{ translateBool(invoice.affected_by_iva) }}</td>
            <td>{{ invoice.folio }}</td>
          </tr>
        </table>
        <div class="table-pagination -centered-info">
          <button class="button button-small" @click="paginationTable(invoicesDetailsData.previous)" :disabled="invoicesDetailsData.previous === null">Anterior</button>
          <button class="button button-small" @click="paginationTable(invoicesDetailsData.next)" :disabled="invoicesDetailsData.next === null">Siguiente</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Preloader from '@/components/Preloader'

import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'ModalInvoicesDetail',
  data () {
    return {
      invoicesDetailsData: [],
      invoicesDetailsStatus: false,
      amount: false
    }
  },
  props: { id: Number },
  mixins: [mixins, httpRequestMixin],
  components: {
    Preloader
  },
  methods: {
    translateBool: function (bool) {
      if (bool === true) {
        return 'Si'
      }
      return 'No'
    },
    toggleAmount: function (value) {
      this.amount = !this.amount
      this.getInvoicesDetails(value)
    },
    getInvoicesDetails: async function (ordering = 'amount') {
      let options = {
        method: 'GET',
        url: this.checkProtocol(`${process.env.AUTH_BASE}/invoices/`),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        params: {
          funding_request: this.id,
          limit: 6,
          offset: 0,
          ordering: ordering
        }
      }

      this.invoicesDetailsStatus = false
      this.invoicesDetailsData = []

      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.invoicesDetailsData = response.data
        this.invoicesDetailsStatus = true
      } else {
        this.$modal.hide('invoices-details')
        this.invoicesDetailsStatus = false
      }
    },
    paginationTable: async function (url) {
      let options = {
        method: 'GET',
        url: this.checkProtocol(url),
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      this.invoicesDetailsStatus = false
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.invoicesDetailsData = response.data
        this.invoicesDetailsStatus = true
      } else {
        this.$modal.hide('invoices-details')
        this.invoicesDetailsStatus = false
      }
    }
  },
  created: function () {
    this.getInvoicesDetails()
  }
}

</script>

<style lang="scss" scoped>

table td,
table th {
  font-size: .9em;
}

</style>



// WEBPACK FOOTER //
// src/views/requestDetail/RequestDetailModalInvoicesDetails.vue